<template>
  <div id="TripPlacesList">
	<b-container>
           <h5 class="text-center">
               {{ $t('AUTHOR') }} : {{ userName }}, {{ $t('TRIP') }} {{ tripName  }}. {{ $t('PLACES') }}
           </h5>
           <b-table
                ref="TripPlacesList"
                selectable
                :items="items"
                :fields="fields"
                striped
                head-row-variant="info"
                @row-selected="onRowSelected"
            >
            </b-table>

        <b-button @click="showAll()">{{ $t('SHOW_ALL') }}</b-button>
        <br><br><br>
    </b-container>
    <b-container fluid class = "footer">
        <center>
            <a v-b-popover.hover.top="$t('TRIP_DESC') " title="">
                <b-button one-line v-on:click = "showTrip()">
                    {{ tripName }}
                </b-button>
            </a>
        </center>
    </b-container>
  </div>
</template>

<script>
import { BContainer, BTable, BButton } from 'bootstrap-vue';

export default {
  name: 'TripPlacesList',
  components: {
    BContainer, BTable, BButton
  },
  data: function() {
    return {
        fields: [
          {
            key: 'placeName',
            label: this.$t('PLACE'),
            sortable: true
          },
          {
            key: 'userName',
            label: this.$t('AUTHOR'),
            sortable: true
          }
        ],
        items: [{}],
        selected: null,
        userName: '',
        tripName: ''
    }
  },
  mounted() {
    this.userName = this.$rmEncHyp(this.$route.params.userName);
    this.tripName = this.$rmEncHyp(this.$route.params.tripName);
    this.getTripPlacesList();
  },
  methods: {
    async getTripPlacesList() {
        try {
            const response = await this.$http.get('/getTripPlacesList', {
                params: {
                    userName: this.userName,
                    tripName: this.tripName
                }
            });
            this.items = response.data;
            if(this.items.length == 0) {
                this.$showMsg(this.$t('EMPTY_LIST'));
                this.$router.go(-1);
            }
        }
        catch(error) {
            if (error.response)
                this.$showErr(error.response.data, error.response.status);
            else this.$showErr(this.$t('SOME_ERROR'));
        }
    },
    onRowSelected(items) {
        let placeName = items[0].placeName;
        let userName = items[0].userName;

        this.$router.push({
            path: '/Place/'+this.$addEncHyp(placeName)+'/'+this.$addEncHyp(userName)
        })
/*
        this.$router.push({
            path: '/Map/PlaceMarker/'+this.$addEncHyp(placeName)+'/'+this.$addEncHyp(userName)
        })
*/
    },
    showTrip() {
        this.$router.push({
            path: '/Tour/'+this.$addEncHyp(this.tripName)+'/'+this.$addEncHyp(this.userName),
        })
    },
    showAll() {
        this.$router.push({
            path: '/Tour/'+this.$addEncHyp(this.tripName)+'/'+this.$addEncHyp(this.userName),
            query: { showAll: true }
        })
    }
  }
}

</script>
<style>
#tbl1Name{
/*    color: blue; */
    font-size: 1.2em;
}
</style>